import React from 'react';
import { View } from '../app-components';
import CardBox from './CardBox';
import HomeStyle from './HomeStyle';
import { carKeysImage } from '../images';

const HowItWorks = () => (
  <View style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
    <View style={HomeStyle.mainHeading}>How it Works</View>
    <View style={HomeStyle.heading}> SEAMLESS OPERATIONS </View>
    <View style={HomeStyle.flexContainer}>
      <View style={HomeStyle.flexContainer__text}>
        How great would it be if every vehicle you desired that pulls into your
        service drive got an offer to purchase? Even better.... without you
        having to train anyone, or rely on anyone to interact with that vehicle?
        Well, here&apos;s the solution!
      </View>
      <View style={HomeStyle.flexContainer__text}>
        AppraiseAll will automatically provide a value to every vehicle you want
        to purchase, as soon as a service writer writes up that vehicle.
        Automated and self-sufficient, the software utilizes your current DMS
        and subscriptions to determine a value for that vehicle, then sends your
        customer an offer, up to 3 different ways, while your customer is still
        in your dealership! All this is accomplished with a set it once and
        forget it design so there is no need for any human interaction.
      </View>
      <View style={HomeStyle.flexBoxForCard}>
        <img src={carKeysImage} style={HomeStyle.imageStyle} alt="carKeys" />
        <CardBox
          head="Fully Automated"
          content={[
            'All of this for less than 2 retail trades per year.',
            'Interested?',
          ]}
        />
      </View>
    </View>
  </View>
);

export default HowItWorks;
